import BottomSheet from '@/shared/components/BottomSheet'
import { Caption } from '@/shared/components/typography'

type CancelFeeInfoProps = {
  isOpen: boolean
  onClick: () => void
}

const CancelFeeInfo = ({ isOpen, onClick }: CancelFeeInfoProps) => {
  const bodyContent = (
    <div className="mb-10 mt-6 flex w-full flex-col px-2">
      <div className="flex flex-col text-left">
        <Caption level="caption1" weight="regular">
          - 이용 12시간 전까지 취소시 전액 환불
        </Caption>
        <Caption level="caption1" weight="regular">
          - 이후 취소 시, 수수료 10,000원 차감 후 환불
        </Caption>
      </div>
    </div>
  )
  return (
    <BottomSheet
      isOpen={isOpen}
      title="결제 취소 수수료 안내"
      className="title1"
      bodyContent={bodyContent}
      btnText="확인"
      onClick={onClick}
    />
  )
}

export default CancelFeeInfo
